/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Date_MonthInputs */

const en_us2_onboarding_date_month = /** @type {(inputs: Onboarding_Date_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MM`)
};

const pt_br2_onboarding_date_month = /** @type {(inputs: Onboarding_Date_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mm`)
};

const es_419_onboarding_date_month = /** @type {(inputs: Onboarding_Date_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mm`)
};

const pt_pt2_onboarding_date_month = /** @type {(inputs: Onboarding_Date_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mm`)
};

const fr_fr2_onboarding_date_month = /** @type {(inputs: Onboarding_Date_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MM`)
};

const de_de2_onboarding_date_month = /** @type {(inputs: Onboarding_Date_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MM`)
};

const it_it2_onboarding_date_month = /** @type {(inputs: Onboarding_Date_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MM`)
};

/**
* | output |
* | --- |
* | "MM" |
*
* @param {Onboarding_Date_MonthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_date_month = /** @type {((inputs?: Onboarding_Date_MonthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Date_MonthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_date_month(inputs)
	if (locale === "es-419") return es_419_onboarding_date_month(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_date_month(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_date_month(inputs)
	if (locale === "de-DE") return de_de2_onboarding_date_month(inputs)
	if (locale === "it-IT") return it_it2_onboarding_date_month(inputs)
	return en_us2_onboarding_date_month(inputs)
});
export { onboarding_date_month as "onboarding.date_month" }